export const BILLINGLIST_INDEX = 'BILLINGLIST_INDEX'
export const BILLINGLIST_SHOW = 'BILLINGLIST_SHOW'
export const BILLINGLIST_SAVE = 'BILLINGLIST_SAVE'



// WEBPACK FOOTER //
// ./src/store/actions/billingList.js